import { useEffect } from 'react';
const PIXEL_ID = '1591693235820229';

/**
 * Meta Pixel loader. Injects the official fbevents.js snippet and fires PageView.
 */
export function MetaPixel() {
  useEffect(() => {
    const w = window as unknown as Record<string, any>;
    if (!w.fbq) {
      const n: any = w.fbq = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-37" data-mp="mkutk7gkdxfe">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-38" data-mp="ml4gtna85qhe" />
    </noscript>;
}